/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Button, Col, Row } from 'reactstrap'

import ReactTable from 'react-table-legacy'
import "react-table-legacy/react-table.css";

import {CopyToClipboard} from 'react-copy-to-clipboard';

import prettyBytes from 'pretty-bytes';

import {AppContext} from '../../AppContext';

class ObjectStreamingHistory extends React.Component
{
  debouncedSaveColumnWidths = null;
  columnKey = 'objectStreamingHistory.columnWidths';

  columnWidths = {};

  componentDidMount()
  {
    this.columnWidths = this.context.appLocalStorage.getColumnWidths(this.state.columns, this.columnKey);
    this.fetchObjectStreamingHistory();
  }

  constructor(props)
  {
    super();

    let columns =
    [
      {Header: 'Start Time', id: 'startTime', accessor: d => {return d.startTime}, 
        Cell: rowInfo => (<div><span title={window.formatTimestamp(rowInfo.row.startTime, true)}>{window.formatTimestamp(rowInfo.row.startTime, false)}</span></div>)},
      {Header: 'End Time', id: 'endTime', accessor: d => {return d.endTime}, 
        Cell: rowInfo => (<div><span title={window.formatTimestamp(rowInfo.row.endTime, true)}>{window.formatTimestamp(rowInfo.row.endTime, false)}</span></div>)},
      {Header: 'Server', id: 'serverName', accessor: 'serverName', 
        Cell: row => <div><span title={row.value}>{row.value}</span></div>},
      {Header: 'User Agent', id: 'userAgent', accessor: 'userAgent', 
        Cell: row => <div><span title={row.value}>{row.value}</span></div>},
      {Header: 'Bytes Streamed', id: 'bytesStreamed', accessor: 'bytesTransmitted',
        Cell: row => (<div><span title={new Intl.NumberFormat().format(parseInt(row.value, 10)) + ' Bytes'}>{prettyBytes(parseInt(row.value, 10))}</span></div>),
        sortMethod: (a, b, desc) =>
        {
          if (a > b)
            return 1;
          else
            return -1;
        }
      },      
      {Header: 'Client IP', id: 'clientIpAddress', accessor: 'clientIpAddress', 
        Cell: row => 
          <div>
            <CopyToClipboard text={row.value} onCopy={() => {this.context.postNotification('info', 'IP address copied to paste buffer.')}}>
              <span title={row.value}>{row.value}</span>
            </CopyToClipboard>
          </div>},
      {Header: 'Referer', id: 'referer', accessor: 'referer', 
        Cell: row => <div><span title={row.value}>{row.value}</span></div>},
      {Header: 'Note', id: 'note', accessor: 'note', Cell: row => <div><span title={row.value}>{row.value}</span></div>}
    ];

    this.debouncedSaveColumnWidths = window.debounce(this.saveColumnWidths, 500);
    this.fetchObjectStreamingHistory = this.fetchObjectStreamingHistory.bind(this);

    this.state =
    {
      columns: columns,
      streamingHistory: []
    }
  }

  async fetchObjectStreamingHistory()
  {
    let bodyData = {objectId: this.props.objectId};
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getObjectStreamingHistory', bodyData);
    this.setState({spinnerIsSpinning: false});
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error loading object streaming history data');
    if (null !== result.jsonData.objectStreamingHistory) this.setState({streamingHistory: result.jsonData.objectStreamingHistory});
  }

  mapBytesStreamed(logEntry)
  {
    return logEntry.bytesTransmitted;
  } 

  render()
  {
    let bytesStreamed = 0;
    if (this.state.streamingHistory.length && 1 === this.state.streamingHistory.length)
      bytesStreamed = parseInt(this.state.streamingHistory[0].bytesTransmitted, 10);
    if (this.state.streamingHistory.length && 1 !== this.state.streamingHistory.length)      
      bytesStreamed = this.state.streamingHistory.map(this.mapBytesStreamed).reduce(this.sumBytesStreamed);
    
    let prettyBytesStreamed = prettyBytes(bytesStreamed);

    return(
      <div>
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2"><Button color='primary' onClick={this.fetchObjectStreamingHistory}>Refresh</Button></Col>
          <Col sm="2">Access Count:</Col>
          <Col sm="1">{new Intl.NumberFormat().format(this.state.streamingHistory.length)}</Col>
          <Col sm="2">Total Bytes:</Col>
          <Col sm="2">{prettyBytesStreamed}</Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col>
            <ReactTable columns={this.state.columns} data={this.state.streamingHistory} minRows={1} className="-striped -highlight" 
              onResizedChange={(resizedColumns, event) => this.debouncedSaveColumnWidths(resizedColumns, event)} />
          </Col>
        </Row>
      </div>
    );
  }

  saveColumnWidths(resizedColumns)
  {
    this.context.appLocalStorage.saveColumnWidths(resizedColumns, this.columnWidths, this.columnKey);
  }

  sumBytesStreamed(prev, next)
  {
    return parseInt(prev, 10) + parseInt(next, 10);
  }
}

ObjectStreamingHistory.contextType = AppContext;

export default ObjectStreamingHistory
